import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Protected } from "@/components/Protected";
import AuthLanding from "@/pages/AuthLanding";
import AuthCallback from "@/pages/AuthCallback";
import Onboarding from "@/pages/Onboarding";
import Home from "@/pages/Home";
import Discover from "@/pages/Discover";
import Post from "@/pages/Post";
import Matches from "@/pages/Matches";
import Messages from "@/pages/Messages";
import Chat from "@/pages/Chat";
import Profile from "@/pages/Profile";
import ListingDetail from "@/pages/ListingDetail";
import PersonDetail from "@/pages/PersonDetail";
import TribeDetail from "@/pages/TribeDetail";
import Saved from "@/pages/Saved";
import Notifications from "@/pages/Notifications";
import SearchPage from "@/pages/Search";
import Admin from "@/pages/Admin";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/login" element={<AuthLanding />} />
      <Route path="/register" element={<AuthLanding />} />
      <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />

      <Route path="/home" element={<Protected tab><Home /></Protected>} />
      <Route path="/discover" element={<Protected tab><Discover /></Protected>} />
      <Route path="/post" element={<Protected tab><Post /></Protected>} />
      <Route path="/matches" element={<Protected tab><Matches /></Protected>} />
      <Route path="/messages" element={<Protected tab><Messages /></Protected>} />
      <Route path="/profile" element={<Protected tab><Profile /></Protected>} />

      <Route path="/listing/:id" element={<Protected><ListingDetail /></Protected>} />
      <Route path="/person/:id" element={<Protected><PersonDetail /></Protected>} />
      <Route path="/tribe/:id" element={<Protected><TribeDetail /></Protected>} />
      <Route path="/chat/:id" element={<Protected><Chat /></Protected>} />
      <Route path="/saved" element={<Protected><Saved /></Protected>} />
      <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
      <Route path="/search" element={<Protected><SearchPage /></Protected>} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />

      <Route path="/" element={<Navigate to="/home" replace />} />
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="app-shell">
          <Toaster position="top-center" richColors />
          <AppRoutes />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}
